import * as fromApi from "../../../core/models/loginResponse";
import { Account } from "../../../core/models/account";

export const createAccounts = (response: fromApi.LoginResponse): Account[] => {
  return response?.accounts?.map((account) => {
    const result: Account = {
      accountNumber: account.accountNumber,
      autoPay: account.autoPay,
      balance: account.balance,
      billType: account.billType,
      cancelled: account.cancelled,
      checklessPay: account.checklessPay,
      dueDate: account.dueDate,
      insured: account.insured,
      minimumDue: account.minDue,
      paperlessBilling: {
        ...account.paperlessBilling,
        account: account.accountNumber,
      },
      payInstrument: account.payInstrument,
      dueDay: account.dueDay,
      transactions: account.transactions?.map((t) => {
        return {
          amount: t.amt,
          balance: t.balance,
          description: t.desc,
          effectiveDate: t.eff,
          policyNumber: t.pol,
          premium: t.prem,
          transactionDate: t.tranEff,
        };
      }),
    };
    return result;
  });
};
